import onBulkActionStopped from 'owa-folder-emptyfolder/lib/actions/onBulkActionStopped';
import getAllTableViewsContainingItemsForFolder from 'owa-mail-triage-table-utils/lib/getAllTableViewsContainingItemsForFolder';
import { mutator } from 'satcheljs';

export default mutator(onBulkActionStopped, actionMessage => {
    clearTableViewLastEmptiedTimeInStore(actionMessage.serverFolderId);
});

// Clear lastEmptiedTime on tableView
// This fixes issues where items are prevented from updating since lastEmptiedTime
// is set but never removed after EmptyFolder is completed. Easily seen when emptying
// DeletedItems then deleting items from another folder (DeletedItems will no longer update)
// since lastEmptiedTime is more recent than item lastDelivery and will result in
// shouldSkipProcessRow returning true.
export function clearTableViewLastEmptiedTimeInStore(serverFolderId: string) {
    const tableViewsForCurrentFolder = getAllTableViewsContainingItemsForFolder(
        serverFolderId,
        false /* shouldIncludeSearchTable */
    );

    tableViewsForCurrentFolder.forEach(tableView => {
        tableView.lastEmptiedTime = null;
    });
}
